import { Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/config";
import AdminPhotos from "./AdminPhotos";
import AdminProducts from "./AdminProducts";
import AdminReviews from "./AdminReviews";
import AdminOrders from "./AdminOrders";

const TABS = [["foto", "Foto", AdminPhotos], ["servizi", "Servizi & Prodotti", AdminProducts], ["recensioni", "Recensioni", AdminReviews], ["ordini", "Ordini", AdminOrders]];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white" data-testid="admin-dashboard">
      <header className="border-b border-red-900/30 bg-black">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src={LOGO} alt="TMS Garage" className="h-12" />
            <span className="hidden sm:block font-display italic uppercase font-bold tracking-wider text-zinc-400">Area riservata</span>
          </div>
          <div className="flex items-center gap-4 text-sm">
            <span className="hidden md:block text-zinc-500" data-testid="admin-user-email">{user?.email}</span>
            <Link to="/" className="text-zinc-400 hover:text-white flex items-center gap-1" data-testid="admin-view-site"><ExternalLink size={15} /> Sito</Link>
            <button onClick={logout} className="text-zinc-400 hover:text-red-500 flex items-center gap-1" data-testid="admin-logout-button"><LogOut size={15} /> Esci</button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-5 lg:px-8 py-10">
        <h1 className="tms-title text-5xl mb-8">Gestione <span className="font-script normal-case text-red-500">officina</span></h1>
        <Tabs defaultValue="foto">
          <TabsList className="bg-[#121215] border border-zinc-800 rounded-none h-auto p-1 flex flex-wrap justify-start">
            {TABS.map(([v, l]) => (
              <TabsTrigger key={v} value={v} className="rounded-none font-display italic uppercase font-bold tracking-wider data-[state=active]:bg-red-600 data-[state=active]:text-white text-zinc-400 px-5 py-2" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(([v, , C]) => (
            <TabsContent key={v} value={v} className="mt-8"><C /></TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  );
}
